// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__MViBS","header":"MessagesList_header__3ZKjh","chat":"MessagesList_chat__1VrOv"};